module.exports = "/_next/static/images/ourPartnersTeslaLogo-563aa30905e9cc645c982da381f1df01.webp";